module.exports = __webpack_public_path__ + "img/eye-close.4d498eff.svg";